import { Alert } from 'components/common';
import { useUser } from 'libs';

export interface ProFilters {
  beacon?: number | string;
  gds?: number | string;
  insurable?: string;
  insurance?: string;
  programs?: string[];
  rate_hold?: number | string;
  regions?: string;
  tds?: number | string;
}

const FreeUserWithProFiltersBanner = ({ filters }: { filters: ProFilters }) => {
  const user = useUser();
  const hasProFilters = (() =>
    filters.beacon ||
    filters.gds ||
    filters.insurable ||
    filters.insurance ||
    filters.programs ||
    filters.rate_hold ||
    filters.regions ||
    filters.tds)();

  if (user.features.is_pro || !hasProFilters) return null;

  return (
    <Alert testId="free-user-with-pro-filters-banner" variant="danger">
      Selected pro filters were not applied. Sign up for Finmo and connect your accounts to get full access to filters
      and other features.
    </Alert>
  );
};

export default FreeUserWithProFiltersBanner;
